export const light = {
  title: 'light',
  text: 'hsl(200, 15%, 8%)',
  background: 'hsl(0, 0%, 98%)',
  spotlight: 'hsl(29, 29%, 75%)',
  element: 'hsl(0, 0%, 100%)',
};

export const dark = {
  title: 'dark',
  text: 'hsl(0, 0%, 100%)',
  spotlight: 'hsl(30, 29%, 3%)',
  element: 'hsl(209, 23%, 22%)',
  background: 'hsl(207, 26%, 17%)',
};
